import { handleAPI, API_VERSION_TWO } from 'utils/apiUtils'

export function cutOffDayLoad() {
  const url = `/${API_VERSION_TWO}/payschedules`
  const method = 'GET'
  const params = { config_name: 'cut_off_day' }

  return {
    type: 'CUT_OFF_DAY_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function isGosiEnabledLoad() {
  const url = `/${API_VERSION_TWO}/payrun_configurations/is_gosi_enabled`
  const method = 'GET'
  const params = {}

  return {
    type: 'IS_GOSI_ENABLED_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function cutOffDayUpdate(data) {
  const url = `/${API_VERSION_TWO}/payschedules`
  const method = 'PUT'
  const params = { config_name: 'cut_off_day' }

  return {
    type: 'CUT_OFF_DAY_UPDATE',
    payload: handleAPI(url, params, method, data),
  }
}

export function loanLimitLoad() {
  const url = `/${API_VERSION_TWO}/payrun_configurations/loan_settings`
  const method = 'GET'
  const params = {}

  return {
    type: 'LOAN_LIMIT_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function loanLimitUpdate(data) {
  const url = `/${API_VERSION_TWO}/payrun_configurations/loan_settings`
  const method = 'PUT'
  const params = {}

  return {
    type: 'LOAN_LIMIT_UPDATE',
    payload: handleAPI(url, params, method, { payrun_configuration: { value: data } }),
  }
}

export function loanLimitBulkUpdate(data) {
  const url = `/${API_VERSION_TWO}/payrun_configurations/bulk_update`
  const method = 'PUT'
  const params = {}

  return {
    type: 'LOAN_LIMIT_BULK_UPDATE',
    payload: handleAPI(url, params, method, { payrun_configurations: data }),
  }
}

export function showDecimalPointsLoad() {
  const url = `/${API_VERSION_TWO}/payrun_configurations/show_decimal_points`
  const method = 'GET'
  const params = {}

  return {
    type: 'SHOW_DECIMAL_POINTS_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function showDecimalPointsUpdate(data) {
  const url = `/${API_VERSION_TWO}/payrun_configurations/show_decimal_points`
  const method = 'PUT'
  const params = {}

  return {
    type: 'SHOW_DECIMAL_POINTS_UPDATE',
    payload: handleAPI(url, params, method, { organization_configuration: data }),
  }
}

export function sendingPayslipLoad() {
  const url = `/${API_VERSION_TWO}/payrun_configurations/is_sending_payslip_enabled`
  const method = 'GET'
  const params = {}

  return {
    type: 'IS_PENDING_PAY_PAYSLIP_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function sendingPayslipUpdate(data) {
  const url = `/${API_VERSION_TWO}/payrun_configurations/is_sending_payslip_enabled`
  const method = 'PUT'
  const params = {}

  return {
    type: 'IS_PENDING_PAY_PAYSLIP_UPDATE',
    payload: handleAPI(url, params, method, { payrun_configuration: data }),
  }
}

export function overtimeCalculationLoad() {
  const url = `/${API_VERSION_TWO}/payrun_configurations/overtime_calculation`
  const method = 'GET'
  const params = {}

  return {
    type: 'OVERTIME_CALCULATION_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function overtimeCalculationUpdate(data) {
  const url = `/${API_VERSION_TWO}/payrun_configurations/overtime_calculation`
  const method = 'PUT'

  return {
    type: 'OVERTIME_CALCULATION_UPDATE',
    payload: handleAPI(url, {}, method, { payrun_configuration: data }),
  }
}

export function delayCalculationLoad() {
  const url = `/${API_VERSION_TWO}/payrun_configurations/late_arrival_calculation`
  const method = 'GET'
  const params = {}

  return {
    type: 'DELAY_CALCULATION_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function delayCalculationUpdate(data) {
  const url = `/${API_VERSION_TWO}/payrun_configurations/late_arrival_calculation`
  const method = 'PUT'
  const params = {}

  return {
    type: 'DELAY_CALCULATION_UPDATE',
    payload: handleAPI(url, params, method, { payrun_configuration: data }),
  }
}

export function isDelayDeductionApplicableLoad() {
  const url = `/${API_VERSION_TWO}/payrun_configurations/is_late_arrival_deduction_applicable`
  const method = 'GET'
  const params = {}

  return {
    type: 'IS_DELAY_DEDUCTION_APPLICABLE_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function isDelayDeductionApplicableUpdate(data) {
  const url = `/${API_VERSION_TWO}/payrun_configurations/is_late_arrival_deduction_applicable`
  const method = 'PUT'
  const params = {}

  return {
    type: 'IS_DELAY_DEDUCTION_APPLICABLE_UPDATE',
    payload: handleAPI(url, params, method, { payrun_configuration: data }),
  }
}

export function absenceCalculationLoad() {
  const url = `/${API_VERSION_TWO}/payrun_configurations/absence_calculation`
  const method = 'GET'
  const params = {}

  return {
    type: 'ABSENCE_CALCULATION_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function absenceCalculationUpdate(data) {
  const url = `/${API_VERSION_TWO}/payrun_configurations/absence_calculation`
  const method = 'PUT'
  const params = {}

  return {
    type: 'ABSENCE_CALCULATION_UPDATE',
    payload: handleAPI(url, params, method, { payrun_configuration: data }),
  }
}

export function isAbsenceDeductionApplicableLoad() {
  const url = `/${API_VERSION_TWO}/absence_deduction_policy`
  const method = 'GET'
  const params = {}

  return {
    type: 'IS_ABSENCE_DEDUCTION_APPLICABLE_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function isAbsenceDeductionApplicableUpdate(data) {
  const url = `/${API_VERSION_TWO}/absence_deduction_policy`
  const method = 'PUT'
  const params = {}

  return {
    type: 'IS_ABSENCE_DEDUCTION_APPLICABLE_UPDATE',
    payload: handleAPI(url, params, method, { absence_deduction_policy: data }),
  }
}

export function vacationCalculationLoad() {
  const url = `/${API_VERSION_TWO}/vacation_salary/elements`
  const method = 'GET'
  const params = {}

  return {
    type: 'VACATION_CALCULATION_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function vacationCalculationUpdate(data) {
  const url = `/${API_VERSION_TWO}/vacation_salary/elements`
  const method = 'PUT'
  const params = {}

  return {
    type: 'VACATION_CALCULATION_UPDATE',
    payload: handleAPI(url, params, method, { configuration: data }),
  }
}

export function unpaidCalculationLoad() {
  const url = `/${API_VERSION_TWO}/organization_configurations/unpaid_calculation`
  const method = 'GET'
  const params = {}

  return {
    type: 'UNPAID_CALCULATION_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function unpaidCalculationUpdate(data) {
  const url = `/${API_VERSION_TWO}/organization_configurations/unpaid_calculation`
  const method = 'PUT'
  const params = {}

  return {
    type: 'UNPAID_CALCULATION_UPDATE',
    payload: handleAPI(url, params, method, { organization_configuration: data }),
  }
}

export function xeroConfigurationLoad() {
  const url = `/${API_VERSION_TWO}/organization_configurations/xero_export_option`
  const method = 'GET'
  const params = {}

  return {
    type: 'XERO_CONFIGURATION_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function xeroConfigurationUpdate(data) {
  const url = `/${API_VERSION_TWO}/organization_configurations/xero_export_option`
  const method = 'PUT'
  const params = {}

  return {
    type: 'XERO_CONFIGURATION_UPDATE',
    payload: handleAPI(url, params, method, { organization_configuration: data }),
  }
}

export function isGosiEnabledUpdate(value) {
  const url = `/${API_VERSION_TWO}/payrun_configurations/is_gosi_enabled`
  const method = 'PUT'
  const params = {}

  return {
    type: 'IS_GOSI_ENABLED_UPDATE',
    payload: handleAPI(url, params, method, { payrun_configuration: { value } }),
  }
}
